module.exports = __webpack_public_path__ + "0b7a0ab903a229fadc8c6f311c5e2fbe.pdf";